import { currentTimeInSeconds, DAY_MINUTES, HOUR_MINUTES, WEEK_MINUTES, YEAR_MONTHS } from '#common/time';
import { InvalidArgumentError } from '#common/types';
import { KeyRangeLock } from '#key-range-locking';
import { LockType } from '#key-range-locking/types';
import { TelemetryName } from '#telemetry/types';
import { SnapshotScheduleType, } from './types';
export const createSnapshotSchedulerClient = (snapshotSchedulerWasm, kvHelperWasm, keyRangeLocking, nodeId, authorizer) => {
    return new SnapshotSchedulerClientImpl(snapshotSchedulerWasm, kvHelperWasm, keyRangeLocking, nodeId, authorizer);
};
export class SnapshotSchedulerClientImpl {
    snapshotSchedulerWasm;
    kvHelperWasm;
    authorizer;
    keyRangeLock;
    constructor(snapshotSchedulerWasm, kvHelperWasm, keyRangeLocking, nodeId, authorizer) {
        this.snapshotSchedulerWasm = snapshotSchedulerWasm;
        this.kvHelperWasm = kvHelperWasm;
        this.authorizer = authorizer;
        const lockOwner = { lockId: 0n, nodeId: nodeId };
        const schedulesRange = this.kvHelperWasm.getSchedulesRange();
        this.keyRangeLock = new KeyRangeLock(keyRangeLocking, lockOwner, LockType.EXCLUSIVE, schedulesRange);
    }
    async create(createParams) {
        this.ensureValidCreateParams(createParams);
        createParams.start ??= BigInt(currentTimeInSeconds());
        const operation = TelemetryName.CREATE_SNAPSHOT_SCHEDULE;
        const telemetryValue = this.kvHelperWasm.makeTelemetryCreateScheduleTuple(createParams.label, createParams.start, snapshotScheduleIntervalToString(createParams.interval), createParams.retention);
        return this.authorizer.executeWithAdminPrivileges(() => {
            return this.keyRangeLock.execute(async () => {
                await this.snapshotSchedulerWasm.createSchedule(createParams);
            });
        }, { operation, telemetryValue });
    }
    async delete(label) {
        const operation = TelemetryName.DELETE_SNAPSHOT_SCHEDULE;
        const telemetryValue = this.kvHelperWasm.makeTelemetryDeleteScheduleTuple(label);
        return this.authorizer.executeWithAdminPrivileges(() => {
            return this.snapshotSchedulerWasm.deleteSchedule(label);
        }, { operation, telemetryValue });
    }
    async list() {
        return this.authorizer.executeWithAdminPrivileges(() => {
            return this.snapshotSchedulerWasm.listSchedules();
        });
    }
    ensureValidCreateParams(createParams) {
        if (createParams.retention < 0) {
            throw new InvalidArgumentError('Retention should not have negative value');
        }
        if (createParams.interval.count < 0) {
            throw new InvalidArgumentError('Interval should not have negative value');
        }
    }
}
function snapshotScheduleIntervalToString(interval) {
    switch (interval.type) {
        case SnapshotScheduleType.YEAR:
            return `${interval.count / YEAR_MONTHS}y`;
        case SnapshotScheduleType.MONTH:
            return `${interval.count}mo`;
        case SnapshotScheduleType.WEEK:
            return `${interval.count / WEEK_MINUTES}w`;
        case SnapshotScheduleType.DAY:
            return `${interval.count / DAY_MINUTES}d`;
        case SnapshotScheduleType.HOUR:
            return `${interval.count / HOUR_MINUTES}h`;
        case SnapshotScheduleType.MINUTE:
            return `${interval.count}m`;
        default:
            return '';
    }
}
